<template>
  <div class="position-relative">
    <input
      :id="inputId"
      v-bind="$attrs"
      v-model="password"
      :placeholder="inputPlaceholder"
      :class="['form-control', inputClass, { 'is-invalid': isInvalid }]"
      :type="showPassword ? 'text' : 'password'"
      :style="{ paddingRight: paddingRight() }"
      @input="$emit('input', $event.target.value)"
    >
    <ValidationMessage
      is-html
      :data-test-id="validationTestId"
      :message="validationMessage"
    />
    <i
      v-if="isCapsLockOn"
      :class="['position-absolute', 'fa-solid fa-sm', 'fa-up-long']"
      :style="{
        top: '20px',
        right: isInvalid ? '55px' : showPassword ? '35px' : '30px',
      }"
    />
    <button
      class="btn p-0 position-absolute"
      type="button"
      :style="[
        {
          lineHeight: '15px',
          top: '11px',
          right: isInvalid ? '33px' : showPassword ? '9px' : '10px',
        },
      ]"
      @click="showPassword = !showPassword"
    >
      <i
        :class="[
          'fa-solid fa-sm',
          { 'fa-eye': !showPassword, 'fa-eye-slash': showPassword },
        ]"
      />
    </button>
  </div>
</template>

<script>
import ValidationMessage from "./ValidationMessage.vue";

export default {
  name: "FormPassword",

  components: { ValidationMessage },

  props: {
    inputClass: {
      type: String,
      required: false,
      default: "",
    },

    inputId: {
      type: String,
      required: false,
      default: "",
    },

    inputPlaceholder: {
      type: String,
      required: false,
      default: "",
    },

    validationTestId: {
      type: String,
      required: true,
    },

    validationMessage: {
      type: String,
      required: false,
      default: "",
    },
  },

  data() {
    return {
      password: "",
      showPassword: false,
      isCapsLockOn: false,
    };
  },

  computed: {
    isInvalid() {
      if (this.validationMessage) return true;
      return false;
    },
  },

  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("keyup", this.onKeyUp);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("keyup", this.onKeyUp);
  },

  methods: {
    onKeyDown(event) {
      try {
        if (event.getModifierState("CapsLock")) {
          this.isCapsLockOn = true;
        }
      } catch {}
    },
    onKeyUp(event) {
      try {
        if (!event.getModifierState("CapsLock")) {
          this.isCapsLockOn = false;
        }
      } catch {}
    },
    paddingRight() {
      let width;

      if (this.isInvalid && this.isCapsLockOn) width = 70;
      if (this.isInvalid && !this.isCapsLockOn) width = 55;
      if (!this.isInvalid && this.isCapsLockOn) width = 48;
      if (!this.isInvalid && !this.isCapsLockOn) width = 30;
      if (this.showPassword) width += 3;

      return `${width}px`;
    },
  },
};
</script>
